module.exports = __webpack_public_path__ + "img/mp.578bde8.png";